import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-itax-app',
  templateUrl: './itax-app.component.html',
  styleUrls: ['./itax-app.component.scss']
})
export class ItaxAppComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

  gotoApp(): void {
    window.open('https://www.itax.me/download', '_blank');
  }

}
